/**
 * How a client is called around the app: its nickname (`shortName`) when it
 * has one, else the company name. Agencies talk about "Dacia", not
 * "Automobile Dacia SA".
 */
export function clientLabel(client: { name: string; shortName?: string | null }): string {
  return client.shortName?.trim() || client.name;
}

// Calendar colours for clients without one set: stable per client id.
const PALETTE = [
  '#2563eb',
  '#db2777',
  '#16a34a',
  '#ea580c',
  '#7c3aed',
  '#0891b2',
  '#ca8a04',
  '#dc2626',
  '#4f46e5',
  '#059669',
];

export function clientColor(client: { id: string; color?: string | null }): string {
  if (client.color) return client.color;
  let hash = 0;
  for (const ch of client.id) hash = (hash * 31 + ch.charCodeAt(0)) >>> 0;
  return PALETTE[hash % PALETTE.length];
}
